// extracted by mini-css-extract-plugin
export default {"container":"eaa-z","productName":"faa-z","price":"gaa-z","dimensions":"haa-z"};